import { TextField, Snackbar, Button } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { useDocument } from "../../firebase-files/hooks/useDocument";
import { useFirestore } from "../../firebase-files/hooks/useFirestore";
import { useAuthContext } from "../../firebase-files/hooks/useAuthContext";
import { useEffect, useState } from "react";
import { projectFirestore } from "../../firebase-config/config";

const TaxesSettings = () => {
  const { user } = useAuthContext();
  const { document } = useDocument("settings", "tax_GST");
  const { updateDocument } = useFirestore("settings");

  const [gstInfo, setGstInfo] = useState("");
  const [cgstInfo, setCgstInfo] = useState("");
  const [sgstInfo, setSgstInfo] = useState("");
  const [cessInfo, setCessInfo] = useState("");

  const [initialData, setInitialData] = useState({});
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  useEffect(() => {
    if (document) {
      setGstInfo(document.gst || "");
      setCgstInfo(document.cgst || "");
      setSgstInfo(document.sgst || "");
      setCessInfo(document.cess || "");

      setInitialData({
        gst: document.gst || "",
        cgst: document.cgst || "",
        sgst: document.sgst || "",
        cess: document.cess || "",
      });
    }
  }, [document]);

  const hasChanged =
    gstInfo !== initialData.gst ||
    cgstInfo !== initialData.cgst ||
    sgstInfo !== initialData.sgst ||
    cessInfo !== initialData.cess;

  const handleSave = async () => {
    const data = {
      gst: gstInfo,
      cgst: cgstInfo,
      sgst: sgstInfo,
      cess: cessInfo,
      updatedBy: user?.uid,
      updatedAt: new Date(),
    };

    try {
      if (document) {
        await updateDocument("tax_GST", data);
      } else {
        await projectFirestore.collection("settings").doc("tax_GST").set(data);
      }
      setSnackbarOpen(true);
      setSnackbarMessage("TAX Updated!");

      // Update initial data and show snackbar
      setInitialData(data);
      setSnackbarOpen(true);
    } catch (err) {
      console.error("Error saving GST info:", err);
    }
  };
  const handleCloseSnackbar = () => {
    setSnackbarOpen(false); // Close snackbar
  };
  return (
    <div>
      <div className="section-title">
        <p>Manage Your Tax Preferences</p>
        <h2>Edit GST Details</h2>
      </div>

      <div className="d-flex gap-3 tax-gst-igst-inputs">
        <TextField
          variant="outlined"
          type="number"
          label="GST"
          value={gstInfo}
          onChange={(e) => setGstInfo(e.target.value)}
          fullWidth
          margin="normal"
        />
        <TextField
          variant="outlined"
          type="number"
          label="CGST"
          value={cgstInfo}
          onChange={(e) => setCgstInfo(e.target.value)}
          fullWidth
          margin="normal"
        />
        <TextField
          variant="outlined"
          type="number"
          label="SGST"
          value={sgstInfo}
          onChange={(e) => setSgstInfo(e.target.value)}
          fullWidth
          margin="normal"
        />
        <TextField
          variant="outlined"
          type="number"
          label="CESS"
          value={cessInfo}
          onChange={(e) => setCessInfo(e.target.value)}
          fullWidth
          margin="normal"
        />
      </div>

      <Button
        variant="contained"
        color={hasChanged ? "primary" : "inherit"}
        onClick={handleSave}
        disabled={!hasChanged}
        style={{ marginTop: "20px" }}
      >
        Save TAX Settings
      </Button>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
      >
        <MuiAlert
          onClose={handleCloseSnackbar}
          severity="success"
          sx={{
            width: "120%",
            backgroundColor: "#ddbcf7",
            color: `var(--click-color)`,
          }}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
};

export default TaxesSettings;
